/**
 * Script de ejemplo para procesar datos del sistema y generar JSONs de Comprobantes Fiscales Electrónicos
 * Este script demuestra cómo utilizar las funciones de generación de e-CF
 */

import { generateECFJson, generateAllECFJsons } from './generateECFJson';

/**
 * Procesa los datos del sistema y genera el JSON correspondiente al tipo de comprobante
 * @param {Object} systemData - Datos del sistema en formato JSON
 * @returns {Object} - JSON del comprobante fiscal electrónico
 */
function processSystemData(systemData) {
  // Verificar si se debe generar un solo JSON o todos los tipos
  const generateAll = systemData.use_ecf && systemData.generate_all_types;
  
  if (generateAll) {
    // Generar JSONs para todos los tipos de comprobantes
    return generateAllECFJsons(systemData);
  } else {
    // Generar JSON solo para el tipo identificado en los datos
    return generateECFJson(systemData);
  }
}

/**
 * Función principal que procesa un archivo de datos y genera los JSONs correspondientes
 * @param {string} dataFilePath - Ruta al archivo de datos del sistema
 * @returns {Object} - JSON o JSONs generados
 */
async function processDataFile(dataFilePath) {
  try {
    // En un entorno real, aquí se cargaría el archivo de datos
    // Para este ejemplo, asumimos que los datos ya están cargados
    const systemData = require(dataFilePath);
    
    // Procesar los datos y generar los JSONs
    const result = processSystemData(systemData);
    
    // Devolver el resultado
    return result;
  } catch (error) {
    console.error('Error al procesar el archivo de datos:', error);
    return null;
  }
}

/**
 * Ejemplo de uso con datos directos
 */
function exampleWithDirectData() {
  // Ejemplo de datos del sistema
  const systemData = {
    invoice_id: 105015,
    business_unit_id: 132,
    business_unit_description: 'SERVICIOS Y CONTR. DEL CARIBE',
    business_unit_rnc: '102622582',
    location_id: 328,
    location_description: 'Serv. & Contr. del Caribe S.A.',
    entity_id: 9,
    entity_name: 'FERRETERIA OCHOA S A',
    entity_document_id: '102003432',
    emission_date: new Date('2025-04-08T19:39:24.000Z'),
    expire_at: new Date('2025-05-08T04:00:00.000Z'),
    currency_id: 1,
    currency_name: 'PESO DOMINICANO (DOP)',
    currency_code: 'DOP',
    invoice_type_id: 2,
    invoice_type_name: 'FACTURA DE VENTA',
    invoice_number: 'SCD0000000005',
    invoice_ncf: 'E3100000004',
    subtotal_amount: '46880',
    taxes_amount: '8438.40',
    total_amount: '55318.40',
    business_unit_address: 'Caribbean Industrial Park de esta ciudad de Santiago de los caballeros',
    created_date: new Date('2025-04-08T19:39:25.243Z'),
    use_ecf: true,
    invoice_details: [
      {
        invoice_id: 105015,
        item_id: 1791,
        item_name: 'TELEVISOR SANKEY 42 PULG–CLED42SDF5',
        total_amount: 46880,
        quantity: 1,
        price: 46880,
        tax_value: 0.18,
        tax_id: 2,
        taxes: 8438.4,
        price_with_taxes: 55318.4,
        warehouse_id: 48,
        unit_id: 38
      }
    ]
  };
  
  // Procesar los datos y generar el JSON
  const result = processSystemData(systemData);
  
  // Mostrar el resultado

  
  // Generar JSONs para todos los tipos
  systemData.generate_all_types = true;
  const allResults = processSystemData(systemData);
  
  // Mostrar un resumen de los resultados

  Object.keys(allResults).forEach(tipo => {
    console.log(`- Tipo ${tipo}: ${JSON.stringify(allResults[tipo].ECF.Encabezado.IdDoc.eNCF)}`);
  });
}

// Exportar las funciones para su uso en otros archivos
export { processSystemData, processDataFile, exampleWithDirectData };